import TextField from "@mui/material/TextField";
import { styled, createTheme } from "@mui/material/styles";

const theme = createTheme();

const hexToRgb = (input) => {
  input = input + "";
  input = input.replace("#", "");
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error("input is not a valid hex color.");
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase();
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return (
    parseInt(first, 16) +
    ", " +
    parseInt(second, 16) +
    ", " +
    parseInt(last, 16)
  );
};

const blackColor = "#000";
const whiteColor = "#FFF";
const grayColor = "#9B9B9B";
const principalColor = "#608D8E";
const secondaryColor = "#39BCC4";
const backgroundColor = "#F5F5F5";

const btnPrincipalColor = "#04808F";
const homeImageBackgroundColor = "#a3e1fa"; //"#3cd5d2";

const button = {
  borderRadius: "10px !important",
  fontSize: "15px!important",
  lineHeight: "24px !important",
  fontWeight: "normal !important",
  textTransform: "unset !important",
  height: "42px",
  letterSpacing: "0px!important",
  [theme.breakpoints.down("md")]: {
    fontSize: "15px!important",
  },
  width: "100%",
};

const outlinedBtn = {
  color: btnPrincipalColor + " !important",
  borderColor: btnPrincipalColor + " !important",
  borderWidth: "1px  !important",
  "&:hover": {
    background: "rgba(95, 141, 141, 40%)  !important",
  },
};

const containedBtn = {
  background: btnPrincipalColor + " !important",
  color: whiteColor + " !important",
  "&:hover": {
    background: "rgba(95, 141, 141, 90%) !important",
  },
};

const textBtn = {
  color: principalColor + " !important",
  "&:hover": {
    background: "rgba(95, 141, 141, 40%) !important",
  },
  [theme.breakpoints.down("md")]: {
    height: "auto",
    paddingTop: "0!important",
    paddingBottom: "0!important",
  },
};

const textUnderlinedBtn = {
  color: blackColor + " !important",
  textDecoration: "underline !important",
  fontWeight: "bold !important",
  "&:hover": {
    background: "unset !important",
  },
};

const helperTxt = {
  display: "flex",
  alignItems: "center",
  gap: 5,
  "&.error": {
    color: "red",
  },
  "&.success": {
    color: "green",
  },
};

const secondaryTxt = {
  fontSize: "10px",
};

const txtTitle = {
  fontSize: "25px",
  lineHeight: "30px",
};

const txtSubTitle = {
  fontSize: "18px",
  lineHeight: "21px",
};

const txtParagraph = {
  fontSize: "15px",
  lineHeight: "18px",
};

const TxtField = styled(TextField)({
  //   "& .MuiOutlinedInput-root": {
  //     "& fieldset": {
  //       borderColor: "#d5d5d5",
  //       borderRadius: "10px",
  //       outline: "none",
  //       color: grayColor,
  //       transition: ".4s all",
  //       ...txtParagraph,
  //     },
  //     "& input": {
  //       fontFamily: "Raleway",
  //       padding: "12px",
  //       borderRadius: "10px",
  //       background: whiteColor,
  //       ...txtParagraph,
  //     },
  //     "& input::placeholder": {
  //       color: grayColor,
  //     },
  //     "&:hover fieldset": {
  //       borderColor: "#5f8d8d",
  //     },
  //     "&.Mui-focused fieldset": {
  //       borderColor: "#5f8d8d",
  //     },
  //   },
});

const headerHeight = 75;
const sideBarWidth = 300;

export {
  theme,
  TxtField,
  hexToRgb,
  blackColor,
  homeImageBackgroundColor,
  whiteColor,
  grayColor,
  principalColor,
  secondaryColor,
  btnPrincipalColor,
  backgroundColor,
  button,
  outlinedBtn,
  containedBtn,
  textBtn,
  textUnderlinedBtn,
  helperTxt,
  txtTitle,
  txtSubTitle,
  txtParagraph,
  headerHeight,
  sideBarWidth,
  secondaryTxt,
};
